<span class="file-icon" *ngIf="filePath">
  <a [href]="storagePath + '/' + filePath" target="_blank" download>
    <i class="icon icon-download is-size-5 has-text-link"></i>
  </a>
</span>
